import {DeepPartial} from 'utility-types';

import {
  GetDirectSaleVariantDefaultVarehousesPriorityResponse,
  GetDirectSaleVariantResponse,
} from '@dms/api/warehouse';
import {buildDepositDefaultValues} from '@dms/settings/shared';

import {Nullish} from 'shared/web';

import {WarehouseDirectSaleVariantsDetailFormSchemaType} from '../types/WarehouseDirectSaleVariantsDetailFormSchema';
import {buildAccountingDefaultValues} from './buildAccountingDefaultValues';
import {buildDocumentsDefaultValues} from './buildDocumentsDefaultValues';
import {buildGeneralDefaultValues} from './buildGeneralDefaultValues';
import {InvoiceTemplateResolvers} from './buildPaymentDocumentsDefaultValues';
import {buildReportingDefaultValues} from './buildReportingDefaultValues';
import {buildWarehousesPriorityDefaultValues} from './buildWarehousesPriorityDefaultValues';

interface WarehouseDirectSaleVariantsDetailDefaultValuesSource {
  directSaleVariantId: string | Nullish;
  directSaleVariant: GetDirectSaleVariantResponse | Nullish;
  authorizationProfileBranchId: string | Nullish;
  defaultWarehousesPriority: GetDirectSaleVariantDefaultVarehousesPriorityResponse | undefined;
  resolvers: InvoiceTemplateResolvers;
}

export function buildWarehouseDirectSaleVariantsDetailDefaultValues(
  source: WarehouseDirectSaleVariantsDetailDefaultValuesSource
): DeepPartial<WarehouseDirectSaleVariantsDetailFormSchemaType> {
  const {directSaleVariant, resolvers} = source;

  return {
    general: buildGeneralDefaultValues(
      directSaleVariant?.general,
      source.authorizationProfileBranchId
    ),
    documents: buildDocumentsDefaultValues(directSaleVariant?.documents, resolvers),
    accounting: buildAccountingDefaultValues(directSaleVariant?.accounting),
    reporting: buildReportingDefaultValues(directSaleVariant?.reporting),
    deposit: buildDepositDefaultValues(
      directSaleVariant?.deposit,
      resolvers.resolveStandardInvoiceTemplateId
    ),
    warehousesPriority: buildWarehousesPriorityDefaultValues(
      source.directSaleVariantId,
      directSaleVariant?.warehousesPriority,
      source.defaultWarehousesPriority
    ),
  };
}
